<script setup>

defineProps({
    links: {
        required: true,
        type: Array
    }
})

</script>

<template>
    <ul class="subnav">
        <li v-for="link in links"><router-link :to="link.to">{{ link.label }}</router-link></li>
    </ul>
</template>

<style lang="scss">
.subnav {
    max-width: var(--max-width);
    margin-inline: auto;
    background: var(--color-grey-mist);
    background: #192D39;
    border-radius: 2.4rem 2.4rem 0 0;

    display: flex;
    justify-content: center;
    align-items: center;
    gap: 4rem;
    position: relative;

    + main {
        height: calc(100dvh - 14rem);
    }

    &:after {
        content: '';
        @include position(absolute, 100% 0 null 0);
        height: 3rem;
        background: #192D39;
    }

    a {
        display: block;
        @include font(1.4, 6, black);
        color: var(--color-white-100);
        padding: 0 1rem;
        box-shadow: inset 0 0 var(--color-theme-primary);
        transition: all .2s ease;

        &:hover {
            color: var(--color-theme-primary);
        }

        &.router-link-active {
            box-shadow: inset 0 -.4rem var(--color-theme-primary);
            color: var(--color-theme-primary);
        }
    }

    @include dark() {
        background: #17242B;

        &:after {
            background: #17242B;
        }
    }
}
</style>
